<script>
export default {
  name: 'AdminShell',
  props: {
    title: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <section class="admin-shell">
    <header v-if="title" class="admin-shell__header">
      <h1 class="admin-page-title">{{ title }}</h1>
      <div class="admin-shell__header-actions">
        <slot name="header-actions" />
      </div>
    </header>

    <div class="admin-shell__content" :class="contentClass">
      <slot />
    </div>
  </section>
</template>

<style scoped>
.admin-shell {
  display: flex;
  flex-direction: column;
  gap: var(--admin-space-4);
}

.admin-shell__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--admin-space-3);
}

.admin-shell__header-actions {
  display: flex;
  align-items: center;
  gap: var(--admin-space-2);
}

.admin-shell__content {
  min-width: 0;
}
</style>
